<template>
    
    <div class="content">
        
        <div class="info-card">
            <div class="user-class">
                <span>邮箱:{{ userInfo.email }}</span>
            </div>

           <div class="btn-class"> 
                <el-button @click="logout()">退出登录</el-button>
                <el-button @click="editPwd()">修改密码</el-button>
           </div>
        </div>
    </div>
    



</template>
  
  <script>
    import {Message} from 'element-ui';
    export default {
      data() {
        return {
            dialogVisible: false,
            userInfo: {},
          
        };
      },
      methods: {
        editPwd(){
            this.goEditPwdPage(this.userInfo);
        },
        login(){
          this.goLoginPage();
        },
        logout(){
            this.$confirm('确定是否退出登录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
             type: 'warning'
            }).then(() => {
                let self = this;
                self.postRequest('/user/loginout',{}).then(resp =>{
                    Message.success({message: resp.msg})
                })
            }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消删除'
            });          
            });
           
        },
        getUserInfo(){
            let self = this;
            self.postRequest('/user/userInfo',{}).then(resp =>{
                self.userInfo = resp.data;    
                self.saveLoginInfo(resp.data);
            })
        },
       
        handleClose(done) {
         this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      }
       
      },
      created(){
        this.getUserInfo();
   
      }
      
    }
  </script>
  <style>
.info-card{
    width: 600px;
    height: 360px;
    background-color: rgb(237, 247, 243);
    border: 1px solid rgb(237, 247, 243);
    margin-top: 10px;
    border-radius: 5px;
    padding-top: 10px;
    margin-left: 35%;
}
.user-class{
    color:burlywood;
    margin-left: 30px;
    margin-top: 10px;
}
.btn-class{
    margin-left: 380px;
    margin-top: 280px;
}
</style>